import React from 'react'
import styled from 'styled-components'
import { Tooltip } from '@intelie/ui'
import { useTooltip } from './helper/LabelWithTooltip'

function LabelWithTooltip({ label = '', tooltipMessenger }: { label: string; tooltipMessenger?: string }) {
    return (
        <Label>
            {label}
            <Tooltip overlay={<>{tooltipMessenger}</>}>
                <Span useTooltip={useTooltip(tooltipMessenger)} />
            </Tooltip>
        </Label>
    )
}

const Label = styled.label`
    width: max-content;
    position: relative;
    display: inline;
`
interface PropsSpan {
    useTooltip: boolean
}
const Span = styled.span<PropsSpan>`
    display: ${({ useTooltip }) => (!useTooltip ? 'none' : undefined)};
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`

export { LabelWithTooltip }
